const updateSportRadarDataText = (dataTitle, dataIntroTop, dataIntroBottom) => {
    const title = document.getElementById("sportradar-title");
    const intro_top = document.getElementById("sportradar-intro-top");
    const intro_bottom = document.getElementById("sportradar-intro-bottom");

    title.innerText = dataTitle;
    if (intro_top) intro_top.innerText = dataIntroTop;
    if (intro_bottom) intro_bottom.innerText = dataIntroBottom;
};

const dualWidgetScript = () => {
    // Only run on Sportradar Data Page that has a dual widget
    const buttonToggleID = document.getElementById("dual-widget-toggle");
    const widgetDiv = document.querySelectorAll(".sr-widget");
    const buttons = document.querySelectorAll(".sportradar-button-options");

    // add active state on first widget
    widgetDiv[0].classList.add("active");
    if (!buttons.length || !widgetDiv.length) {
        buttonToggleID.classList.add("hidden");
        return;
    }

    buttons.forEach((btn, index) => {
        btn.addEventListener("click", (e) => {
            buttons.forEach((b) => b.classList.remove("active"));
            e.target.classList.add("active");

            widgetDiv.forEach((b) => b.classList.remove("active"));
            widgetDiv[index].classList.add("active");

            updateSportRadarDataText(
                btn.dataset.title,
                btn.dataset.introTop,
                btn.dataset.introBottom,
            );
        });
    });

    // add active button state on first load of page
    buttons[0].classList.add("active");
};

document.addEventListener("DOMContentLoaded", () => {
    dualWidgetScript();
});
